import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FileDownloadDirective } from './file-download.directive';
import { FileService } from './file.service';
import { ZipDownloadDirective } from './zip-download.directive';

/**
 * Module used to manage with files
 * - File download
 * - Zip downloads
 * - File uploads
 */
@NgModule({
  declarations: [ZipDownloadDirective, FileDownloadDirective],
  imports: [CommonModule],
  providers: [FileService],
  exports: [ZipDownloadDirective, FileDownloadDirective],
})
export class FileModule {}
